import type { FaireProductEntity } from "../../entity_types/product";

export const p_pnxa66qjgc: FaireProductEntity = {
  token: "p_pnxa66qjgc",
  type: "product",
  name: "ADENA CHOCOLATE - Fisherman Slingback Sandals",
  brandToken: "b_fpf4yb7vsz",
  brandName: "KMB Shoes",
  imageUrl: "https://cdn.faire.com/fastly/b576d6b4d10145b733c385ebc10b15d51ed2b31b5b72f83eee1cc4be70175391.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f42febf5ee2aca2b1104f57d7ab6ca6b3110d6c36299ee7d6472a9429f087e2a.jpeg",
    "https://cdn.faire.com/fastly/d28c54a5a9383d0bcfb8a5a39a70c01520109bc82aa1d61a870147c2f1c40993.jpeg",
    "https://cdn.faire.com/fastly/f77b8693acb6afcadf79dc59907c7ac2931c1fc07bd6f41e664b1cbb04479d7c.jpeg",
    "https://cdn.faire.com/fastly/04084cd242a1a77072798b1bccf90dcca0c8d6081d0e17795ad8d26f207c0283.jpeg",
    "https://cdn.faire.com/fastly/abc1e87c555828e2ff292528f2b0b9f8f7e2134faddd93b7ddcae3480e8b0b4e.jpeg",
    "https://cdn.faire.com/fastly/815fbb27520fe322ea039d1049e88aab87dc87e4b0f30b038231381d3b41ac42.jpeg"
  ],
  priceDollars: 69.99,
  description: "Adena Chocolate - Fisherman Slingback Sandals\n\nAdena blends refined minimalism with effortless comfort. Crafted from soft leather, these lightweight sandals feature a structured yet elegant design, complete with a sleek square toe and an adjustable slingback strap for a secure fit. The softly padded insole ensures all-day comfort, making Adena the perfect choice for a woman with a chic, understated style. Whether for a relaxed stroll or a polished work ensemble, these sandals bring sophistication to every step.\n\n• Product Type: Slingback Cage Sandals\n• Material: Leather\n• Lining: Microfiber Lining\n• Insole: Leather\n• Platform Height: 0.5 cm\n• Color: Chocolate (Moka Brown)\n• Outsole: Rubber Sole\n• Special Feature: Square Toe, Slingback, Buckle Fastening\n• Fit: True to Size\n• Made in Spain",
  tags: [],
  msrpDollars: 139.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:52.778Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
